import {
    Center,
    Group
} from "@mantine/core";
import {
    FlexiButton,
    PlatformFieldset
} from "@flexinet/ui-components";
import {AiOutlineGoogle,} from "react-icons/ai";
import {
    signInWithRedirect,
    SignInWithRedirectInput
} from "aws-amplify/auth";


export const SocialSignUpFieldset = () => {

    const googleSignInWithRedirectInput = {provider: 'Google'} as SignInWithRedirectInput

    return (
        <PlatformFieldset legend={'Sign Up with Social Account'}
                          px={'xl'}
                          mb={'xl'}>
            <Center>
                <Group
                    my={'lg'}
                >
                    <FlexiButton variant={'outline'} size={'xl'} radius={'sm'}
                                 leftSection={<AiOutlineGoogle size={'1.6em'}/>}
                                 onClick={(e) => {
                                     e.preventDefault()
                                     signInWithRedirect(googleSignInWithRedirectInput)
                                 }}>Google</FlexiButton>


                </Group>
            </Center>
        </PlatformFieldset>

    )
}

